import script from "./legoStepBoxExtend.vue?vue&type=script&lang=js"
export * from "./legoStepBoxExtend.vue?vue&type=script&lang=js"

import "./legoStepBoxExtend.vue?vue&type=style&index=0&id=992b625e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-992b625e"],['__file',"src/components/lego/extend/legoStepBoxExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "992b625e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('992b625e', __exports__)) {
    api.reload('992b625e', __exports__)
  }
  
}


export default __exports__